import { render, staticRenderFns } from "./table2019.vue?vue&type=template&id=435cb36c&scoped=true"
import script from "./table2019.vue?vue&type=script&lang=js"
export * from "./table2019.vue?vue&type=script&lang=js"
import style0 from "./table2019.vue?vue&type=style&index=0&id=435cb36c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435cb36c",
  null
  
)

export default component.exports